export const nullOrCastToNumber = (
    value?: null | string | number,
): null | number =>
    value === null ||
    value === undefined ||
    Number.isNaN(Number(value)) ||
    !value.toString().trim()
        ? null
        : Number(value);
